/**
 * Studio Management Page - Buried Point Configuration
 * 埋点配置 - 工作室管理页
 *
 * ID Allocation:
 * - 100021: Studio - Portfolio Overview page
 * - 100022: Studio - Studios page
 * - 100023: Studio - Live Titles page
 * - 100024: Studio - In Dev Projects page
 * - Buttons: {pageId}001, {pageId}002, etc.
 */

const typeId = 'mgmt_pc_v2';
const source = 0;

// Portfolio Overview Sub-tab (as a page view)
export const PortfolioOverviewTab = {
  pageName: 'Studio Management - Portfolio Overview',
  pageId: '100021',
  pagePath: '/strategic/home?tab=studio&subtitle=portfolio',
  common: {
    source,
    typeId,
  },
  button: {
    // Tab click button
    tabClick: {
      buttonId: '100021001',
      buttonName: 'Portfolio Overview',
    },
    // Board Governance button
    // boardGovernance: {
    //   buttonId: '100021002',
    //   buttonName: 'Board Governance',
    // },
    // Revenue metric card button
    revenueMetricCard: {
      buttonId: '100021003',
      buttonName: 'Revenue Metric Card',
    },
    // Profit metric card button
    profitMetricCard: {
      buttonId: '100021004',
      buttonName: 'Profit Metric Card',
    },
    // Trend View button (used for both Revenue and Profit)
    revenueTrendView: {
      buttonId: '100021005',
      buttonName: 'Trend - View',
    },
    // Trend Line Chart button (used for both Revenue and Profit)
    revenueTrendLineChart: {
      buttonId: '100021006',
      buttonName: 'Trend - Line Chart',
    },
    // Trend Bar Chart button (used for both Revenue and Profit)
    revenueTrendBarChart: {
      buttonId: '100021007',
      buttonName: 'Trend - Bar Chart',
    },
    // Trend Table button (used for both Revenue and Profit)
    revenueTrendTable: {
      buttonId: '100021008',
      buttonName: 'Trend - Table',
    },
    // Trend Download button (used for both Revenue and Profit)
    revenueTrendDownload: {
      buttonId: '100021009',
      buttonName: 'Trend - Download',
    },
    // Phase Table Collapse/Expand button
    phaseTableCollapse: {
      buttonId: '100021010',
      buttonName: 'Phase Table Collapse/Expand',
    },
    // More Board/General Resolution Link button
    // moreBoardLink: {
    //   buttonId: '100021011',
    //   buttonName: 'More Board/General Resolution Link',
    // },
    // Studio Click button (in Board Governance table)
    // studioClick: {
    //   buttonId: '100021012',
    //   buttonName: 'Studio Click',
    // },
    // Board Meeting Click button (in Board Governance table)
    // boardMeetingClick: {
    //   buttonId: '100021013',
    //   buttonName: 'Board Meeting Click',
    // },
    // Phase Table Edit button
    phaseTableEdit: {
      buttonId: '100021014',
      buttonName: 'Phase Table Edit',
    },
    // Board Governance Edit button
    // boardGovernanceEdit: {
    //   buttonId: '100021015',
    //   buttonName: 'Board Governance Edit',
    // },
    // Month Picker (top filter)
    monthPicker: {
      buttonId: '100021016',
      buttonName: 'Month Picker',
    },
    // Show Events checkbox
    showEvents: {
      buttonId: '100021017',
      buttonName: 'Show Events',
    },
    // By Month segment button
    byMonth: {
      buttonId: '100021018',
      buttonName: 'By Month',
    },
    // By Year segment button
    byYear: {
      buttonId: '100021019',
      buttonName: 'By Year',
    },
    // Notes Edit button (in PlainText component)
    notesEdit: {
      buttonId: '100021020',
      buttonName: 'Notes Edit',
    },
    // Board Meeting Share button (in Board Governance table)
    // boardMeetingShare: {
    //   buttonId: '100021021',
    //   buttonName: 'Board Meeting Share Icon Click',
    // },
    // // Board Meeting Share Confirm button (in Share modal)
    // boardMeetingShareConfirm: {
    //   buttonId: '100021022',
    //   buttonName: 'Board Meeting Share Confirm',
    // },
    pipelineCalendarSegment: {
      buttonId: '100021023',
      buttonName: 'Portfolio Overview Pipeline Calendar Segment',
    },
    pipelineCalendarEdit: {
      buttonId: '100021024',
      buttonName: 'Portfolio Overview Pipeline Calendar Edit',
    },
    pipelineCalendarFullScreen: {
      buttonId: '100021025',
      buttonName: 'Portfolio Overview Pipeline Calendar FullScreen',
    },
    pipelineCalendarFilterType: {
      buttonId: '100021026',
      buttonName: 'Portfolio Overview Pipeline Calendar FilterType',
    },
    pipelineCalendarEventClick: {
      buttonId: '100021027',
      buttonName: 'Portfolio Overview Pipeline Calendar EventClick',
    },
    pipelineCalendarProjectRedirectClick: {
      buttonId: '100021028',
      buttonName: 'Portfolio Overview Pipeline Calendar Project Redirect Click',
    },
    // Operational metrics (Burn Rate / Headcount / Staff Rate)
    burnRate: {
      buttonId: '100021029',
      buttonName: 'Burn Rate',
    },
    burnRateBarChart: {
      buttonId: '100021030',
      buttonName: 'Burn Rate - Bar Chart',
    },
    burnRateTable: {
      buttonId: '100021031',
      buttonName: 'Burn Rate - Table',
    },
    burnRateView: {
      buttonId: '100021032',
      buttonName: 'Burn Rate - View',
    },
    headcount: {
      buttonId: '100021033',
      buttonName: 'Headcount',
    },
    headcountBarChart: {
      buttonId: '100021034',
      buttonName: 'Headcount - Bar Chart',
    },
    headcountTable: {
      buttonId: '100021035',
      buttonName: 'Headcount - Table',
    },
    headcountView: {
      buttonId: '100021036',
      buttonName: 'Headcount - View',
    },
    staffRate: {
      buttonId: '100021037',
      buttonName: 'Staff Rate',
    },
    staffRateBarChart: {
      buttonId: '100021038',
      buttonName: 'Staff Rate - Bar Chart',
    },
    staffRateTable: {
      buttonId: '100021039',
      buttonName: 'Staff Rate - Table',
    },
    staffRateView: {
      buttonId: '100021040',
      buttonName: 'Staff Rate - View',
    },
    headcountCategoryLevel: {
      buttonId: '100021041',
      buttonName: 'Headcount - Category Level',
    },
    metricsDownload: {
      buttonId: '100021042',
      buttonName: 'Portfolio Metrics - Download',
    },
    metricsByMonth: {
      buttonId: '100021043',
      buttonName: 'Portfolio Metrics - By Month',
    },
    metricsByYear: {
      buttonId: '100021044',
      buttonName: 'Portfolio Metrics - By Year',
    },
  },
};

// Studios Sub-tab (as a page view)
export const StudiosTab = {
  pageName: 'Studio Management - Studios',
  pageId: '100022',
  pagePath: '/strategic/home?tab=studio&subtitle=studio',
  common: {
    source,
    typeId,
  },
  button: {
    // Tab click button
    tabClick: {
      buttonId: '100022001',
      buttonName: 'Studios',
    },
    // Board Governance button
    // boardGovernance: {
    //   buttonId: '100022002',
    //   buttonName: 'Board Governance',
    // },
    // More Board/General Resolution Link button
    // moreBoardLink: {
    //   buttonId: '100022003',
    //   buttonName: 'More Board/General Resolution Link',
    // },
    // Studio Click button (in Board Governance table)
    // studioClick: {
    //   buttonId: '100022004',
    //   buttonName: 'Studio Click',
    // },
    // Revenue metric card button
    revenueMetricCard: {
      buttonId: '100022005',
      buttonName: 'Revenue Metric Card',
    },
    // Profit metric card button
    profitMetricCard: {
      buttonId: '100022006',
      buttonName: 'Profit Metric Card',
    },
    // Trend View button (used for both Revenue and Profit)
    revenueTrendView: {
      buttonId: '100022007',
      buttonName: 'Trend - View',
    },
    // Trend Line Chart button (used for both Revenue and Profit)
    revenueTrendLineChart: {
      buttonId: '100022008',
      buttonName: 'Trend - Line Chart',
    },
    // Trend Bar Chart button (used for both Revenue and Profit)
    revenueTrendBarChart: {
      buttonId: '100022009',
      buttonName: 'Trend - Bar Chart',
    },
    // Trend Table button (used for both Revenue and Profit)
    revenueTrendTable: {
      buttonId: '100022010',
      buttonName: 'Trend - Table',
    },
    // Trend Download button (used for both Revenue and Profit)
    revenueTrendDownload: {
      buttonId: '100022011',
      buttonName: 'Trend - Download',
    },
    // By Month segment button
    byMonth: {
      buttonId: '100022012',
      buttonName: 'By Month',
    },
    // By Year segment button
    byYear: {
      buttonId: '100022013',
      buttonName: 'By Year',
    },
    // Headcount tab button
    headcount: {
      buttonId: '100022014',
      buttonName: 'Headcount',
    },
    // Staff Rate tab button
    staffRate: {
      buttonId: '100022015',
      buttonName: 'Staff Rate',
    },
    // Studio Financials - Bar Chart button
    studioFinancialsBarChart: {
      buttonId: '100022016',
      buttonName: 'Studio Financials - Bar Chart',
    },
    // Studio Financials - Table button
    studioFinancialsTable: {
      buttonId: '100022017',
      buttonName: 'Studio Financials - Table',
    },
    // Studio Financials - Download button
    // studioFinancialsDownload: {
    //   buttonId: '100022018',
    //   buttonName: 'Studio Financials - Download',
    // },
    // Headcount - Bar Chart button
    headcountBarChart: {
      buttonId: '100022019',
      buttonName: 'Headcount - Bar Chart',
    },
    // Headcount - Table button
    headcountTable: {
      buttonId: '100022020',
      buttonName: 'Headcount - Table',
    },
    // Headcount - Download button
    // headcountDownload: {
    //   buttonId: '100022021',
    //   buttonName: 'Headcount - Download',
    // },
    // Staff Rate - Bar Chart button
    staffRateBarChart: {
      buttonId: '100022022',
      buttonName: 'Staff Rate - Bar Chart',
    },
    // Staff Rate - Table button
    staffRateTable: {
      buttonId: '100022023',
      buttonName: 'Staff Rate - Table',
    },
    // Staff Rate - Download button
    // staffRateDownload: {
    //   buttonId: '100022024',
    //   buttonName: 'Staff Rate - Download',
    // },
    // Board Meeting Click button (in Board Governance table)
    // boardMeetingClick: {
    //   buttonId: '100022025',
    //   buttonName: 'Board Meeting Click',
    // },
    // Studio Select button (in GameSelect dropdown)
    studioSelect: {
      buttonId: '100022026',
      buttonName: 'Studio Select',
    },
    // Notes Edit button (in PlainText component)
    notesEdit: {
      buttonId: '100022027',
      buttonName: 'Notes Edit',
    },
    // Board Governance Edit button
    // boardGovernanceEdit: {
    //   buttonId: '100022028',
    //   buttonName: 'Board Governance Edit',
    // },
    // Month Picker (top filter)
    monthPicker: {
      buttonId: '100022029',
      buttonName: 'Month Picker',
    },
    // Board Meeting Share button (in Board Governance table)
    // boardMeetingShare: {
    //   buttonId: '100022030',
    //   buttonName: 'Board Meeting Share Icon Click',
    // },
    // // Board Meeting Share Confirm button (in Share modal)
    // boardMeetingShareConfirm: {
    //   buttonId: '100022031',
    //   buttonName: 'Board Meeting Share Confirm',
    // },
    // Show Events checkbox (in Revenue/Profit Trend chart)
    showEvents: {
      buttonId: '100022032',
      buttonName: 'Show Events',
    },
    // Financials tab button (in Financials card)
    financials: {
      buttonId: '100022033',
      buttonName: 'Financials',
    },
    // Burn Rate tab button (in Financials card)
    burnRate: {
      buttonId: '100022034',
      buttonName: 'Burn Rate',
    },
    // Burn Rate - Bar Chart button
    burnRateBarChart: {
      buttonId: '100022035',
      buttonName: 'Burn Rate - Bar Chart',
    },
    // Burn Rate - Table button
    burnRateTable: {
      buttonId: '100022036',
      buttonName: 'Burn Rate - Table',
    },
    // Burn Rate - Download button
    // burnRateDownload: {
    //   buttonId: '100022037',
    //   buttonName: 'Burn Rate - Download',
    // },
    // Studio Financials - View button
    studioFinancialsView: {
      buttonId: '100022038',
      buttonName: 'Studio Financials - View',
    },
    // Burn Rate - View button
    burnRateView: {
      buttonId: '100022039',
      buttonName: 'Burn Rate - View',
    },
    // Headcount - View button
    headcountView: {
      buttonId: '100022040',
      buttonName: 'Headcount - View',
    },
    // Staff Rate - View button
    staffRateView: {
      buttonId: '100022041',
      buttonName: 'Staff Rate - View',
    },
    pipelineCalendarSegment: {
      buttonId: '100022042',
      buttonName: 'Studio Pipeline Calendar Segment',
    },
    pipelineCalendarEdit: {
      buttonId: '100022043',
      buttonName: 'Studio Pipeline Calendar Edit',
    },
    pipelineCalendarFullScreen: {
      buttonId: '100022044',
      buttonName: 'Studio Pipeline Calendar FullScreen',
    },
    pipelineCalendarFilterType: {
      buttonId: '100022045',
      buttonName: 'Studio Pipeline Calendar FilterType',
    },
    pipelineCalendarEventClick: {
      buttonId: '100022046',
      buttonName: 'Studio Pipeline Calendar EventClick',
    },
    pipelineCalendarProjectRedirectClick: {
      buttonId: '100022047',
      buttonName: 'Studio Pipeline Calendar Project Redirect Click',
    },
    // Edit All Studios Notes button (batch notes modal)
    editAllStudiosNotes: {
      buttonId: '100022048',
      buttonName: 'Edit All Studios Notes',
    },
    // Headcount category level radio (Level 1 / Level 2 / Functions)
    headcountCategoryLevel: {
      buttonId: '100022049',
      buttonName: 'Headcount - Category Level',
    },
    // Studios metrics download icon (By Month / By Year card toolbar)
    metricsDownload: {
      buttonId: '100022050',
      buttonName: 'Studios Metrics - Download',
    },
  },
};

// Live Titles Sub-tab (as a page view)
export const LiveTitlesTab = {
  pageName: 'Studio Management - Live Titles',
  pageId: '100023',
  pagePath: '/strategic/home?tab=studio&subtitle=titles&live_view=business&game_title=all',
  common: {
    source,
    typeId,
  },
  button: {
    // Tab click button
    tabClick: {
      buttonId: '100023001',
      buttonName: 'Live Titles',
    },
    // Data Analytics button
    dataAnalytics: {
      buttonId: '100023002',
      buttonName: 'Data Analytics',
    },
    // Download button
    download: {
      buttonId: '100023003',
      buttonName: 'Download',
    },
    // YoY checkbox
    yoy: {
      buttonId: '100023004',
      buttonName: 'YoY',
    },
    // MoM checkbox
    mom: {
      buttonId: '100023005',
      buttonName: 'MoM',
    },
    // Aggregated by selected period checkbox
    aggregated: {
      buttonId: '100023006',
      buttonName: 'Aggregated by selected period',
    },
    // Metric Switcher - Gross
    metricSwitcherGross: {
      buttonId: '100023007',
      buttonName: 'Metric Switcher - Gross',
    },
    // Metric Switcher - Net
    metricSwitcherNet: {
      buttonId: '100023008',
      buttonName: 'Metric Switcher - Net',
    },
    // Studio Select (in GameSelect dropdown)
    studioSelect: {
      buttonId: '100023009',
      buttonName: 'Studio Select',
    },
    // Notes Edit button (in PlainText component)
    notesEdit: {
      buttonId: '100023010',
      buttonName: 'Notes Edit',
    },
    // Live Visualization All - Edit button
    liveVisualizationAllEdit: {
      buttonId: '100023011',
      buttonName: 'Live Visualization All - Edit',
    },
    // Live Visualization All - overview card click (MC/LO via extInfo)
    liveVisualizationAllOverviewCardClick: {
      buttonId: '100023012',
      buttonName: 'Live Visualization All - Overview Card Click',
    },
    // Live Visualization All - project redirect click
    liveVisualizationAllProjectRedirectClick: {
      buttonId: '100023013',
      buttonName: 'Live Visualization All - Project Redirect Click',
    },
    // Live Titles - Business/Finance live view segment
    liveViewSegment: {
      buttonId: '100023014',
      buttonName: 'Live Titles Live View Segment',
    },
    // Live Finance - Edit button
    liveFinanceEdit: {
      buttonId: '100023015',
      buttonName: 'Live Finance - Edit',
    },
  },
};

// In Dev Projects Sub-tab (as a page view)
export const InDevProjectsTab = {
  pageName: 'Studio Management - In Dev Projects',
  pageId: '100024',
  pagePath: '/strategic/home?tab=studio&subtitle=projects',
  common: {
    source,
    typeId,
  },
  button: {
    // Tab click button
    tabClick: {
      buttonId: '100024001',
      buttonName: 'In Dev Projects',
    },
    // GR Management button
    grManagement: {
      buttonId: '100024002',
      buttonName: 'GR Management',
    },
    // Project Select (in GameSelect dropdown)
    projectSelect: {
      buttonId: '100024003',
      buttonName: 'Project Select',
    },
    // Lifecycle Financial Forecast - Line Chart
    lifecycleFinancialForecastBarChart: {
      buttonId: '100024004',
      buttonName: 'Lifecycle Financial Forecast - Bar Chart',
    },
    // Lifecycle Financial Forecast - Table
    lifecycleFinancialForecastTable: {
      buttonId: '100024005',
      buttonName: 'Lifecycle Financial Forecast - Table',
    },
    // Lifecycle Financial Forecast - Download
    lifecycleFinancialForecastDownload: {
      buttonId: '100024006',
      buttonName: 'Lifecycle Financial Forecast - Download',
    },
    // By Month segment
    byMonth: {
      buttonId: '100024007',
      buttonName: 'By Month',
    },
    // By Phase segment
    byPhase: {
      buttonId: '100024008',
      buttonName: 'By Phase',
    },
    // In Dev Title Spend Trend - Bar Chart
    spendTrendBarChart: {
      buttonId: '100024009',
      buttonName: 'In Dev Title Spend Trend - Bar Chart',
    },
    // In Dev Title Spend Trend - Table
    spendTrendTable: {
      buttonId: '100024010',
      buttonName: 'In Dev Title Spend Trend - Table',
    },
    // In Dev Title Spend Trend - Download
    spendTrendDownload: {
      buttonId: '100024011',
      buttonName: 'In Dev Title Spend Trend - Download',
    },
    // Headcount Ramp - Bar Chart
    headcountRampBarChart: {
      buttonId: '100024012',
      buttonName: 'Headcount Ramp - Bar Chart',
    },
    // Headcount Ramp - Table
    headcountRampTable: {
      buttonId: '100024013',
      buttonName: 'Headcount Ramp - Table',
    },
    // Headcount Ramp - Download
    headcountRampDownload: {
      buttonId: '100024014',
      buttonName: 'Headcount Ramp - Download',
    },
    // Milestone Card Click
    milestoneCardClick: {
      buttonId: '100024015',
      buttonName: 'Milestone Card Click',
    },
    // Headcount Card Edit
    headcountCardEdit: {
      buttonId: '100024016',
      buttonName: 'Headcount Card Edit',
    },
    // Lifecycle Financial Forecast Edit
    lifecycleFinancialForecastEdit: {
      buttonId: '100024017',
      buttonName: 'Lifecycle Financial Forecast Edit',
    },
    // GR Management Edit
    grManagementEdit: {
      buttonId: '100024018',
      buttonName: 'GR Management Edit',
    },
    // Month Picker (top filter)
    monthPicker: {
      buttonId: '100024019',
      buttonName: 'Month Picker',
    },
    // Notes Edit button (in PlainText component)
    notesEdit: {
      buttonId: '100024020',
      buttonName: 'Notes Edit',
    },
    // Lifecycle Financial Forecast - View
    lifecycleFinancialForecastView: {
      buttonId: '100024021',
      buttonName: 'Lifecycle Financial Forecast - View',
    },
    // In Dev Title Spend Trend - View
    spendTrendView: {
      buttonId: '100024022',
      buttonName: 'In Dev Title Spend Trend - View',
    },
    // Headcount Ramp - View
    headcountRampView: {
      buttonId: '100024023',
      buttonName: 'Headcount Ramp - View',
    },
    // In Dev Projects All - Edit button
    inDevProjectsAllEdit: {
      buttonId: '100024024',
      buttonName: 'In Dev Projects All - Edit',
    },
    // In Dev Projects All - project redirect click
    inDevProjectsAllProjectRedirectClick: {
      buttonId: '100024025',
      buttonName: 'In Dev Projects All - Project Redirect Click',
    },
    // Download button
    download: {
      buttonId: '100024026',
      buttonName: 'Download',
    },
    // Data Analytics button
    dataAnalytics: {
      buttonId: '100024027',
      buttonName: 'Data Analytics',
    },
  },
};

// Board Governance sub-tab (as a page view)
export const BoardGovernanceTab = {
  pageName: 'Studio Management - Board Governance',
  pageId: '100025',
  pagePath: '/strategic/home?tab=studio&subtitle=boardGovernance',
  common: {
    source,
    typeId,
  },
  button: {
    tabClick: {
      buttonId: '100025001',
      buttonName: 'Board Governance',
    },
    // studioFilter: {
    //   buttonId: '100025002',
    //   buttonName: 'Studio Filter',
    // },
    boardGovernanceEdit: {
      buttonId: '100025002',
      buttonName: 'Board Governance Edit',
    },
    boardMeetingClick: {
      buttonId: '100025003',
      buttonName: 'Board Meeting Click',
    },
    boardMeetingShare: {
      buttonId: '100025004',
      buttonName: 'Board Meeting Share Icon Click',
    },
    boardMeetingShareConfirm: {
      buttonId: '100025005',
      buttonName: 'Board Meeting Share Confirm',
    },
  },
};

// Export all configs
export default {
  portfolio: PortfolioOverviewTab,
  studio: StudiosTab,
  titles: LiveTitlesTab,
  projects: InDevProjectsTab,
  boardGovernance: BoardGovernanceTab,
};
